const tintColorLight = '#373737';
const tintColorDark = '#FDFBF7';

export default {
  light: {
    text: '#373737',
    background: '#FDFBF7',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: '#FDFBF7',
    background: '#242526',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
  },
};
